import React, { useState, useEffect } from 'react';
import { TextSelection } from '../../types/document';

interface TextSelectionButtonProps {
  selection: TextSelection;
  onAddToDocument: () => void;
}

export const TextSelectionButton: React.FC<TextSelectionButtonProps> = ({
  selection,
  onAddToDocument
}) => {
  if (!selection?.rect) return null;

  // const buttonStyle: React.CSSProperties = {
  //   position: 'fixed',
  //   top: selection.rect.top - 40,
  //   left: selection.rect.left + selection.rect.width / 2 - 60,
  //   zIndex: 9999,
  //   backgroundColor: '#007bff',
  //   color: 'white',
  //   border: 'none',
  //   borderRadius: '4px',
  //   padding: '6px 12px',
  //   fontSize: '12px',
  //   cursor: 'pointer',
  //   boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
  // };

  const [buttonPosition, setButtonPosition] = useState({
    top: selection.rect.top - 40,
    left: selection.rect.left + selection.rect.width / 2 - 60
  });

  useEffect(() => {
    const handleScroll = () => {
      // 获取当前选择的最新位置信息
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        const range = sel.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        
        // 计算按钮位置，确保在视窗内
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        
        // 基本位置计算
        let top = rect.top + scrollTop - 40;
        let left = rect.left + scrollLeft + rect.width / 2 - 60;
        
        // 确保按钮在视窗内
        const buttonWidth = 120; // 按钮大约宽度
        const buttonHeight = 32;  // 按钮大约高度
        
        // 检查是否超出右边界
        if (left + buttonWidth > window.innerWidth + scrollLeft) {
          left = window.innerWidth + scrollLeft - buttonWidth - 10;
        }
        
        // 检查是否超出左边界
        if (left < scrollLeft + 10) {
          left = scrollLeft + 10;
        }
        
        // 检查是否超出上边界
        if (top < scrollTop + 10) {
          // 如果上方空间不足，显示在选择文本下方
          top = rect.bottom + scrollTop + 10;
        }
        
        // 检查是否超出下边界
        if (top + buttonHeight > window.innerHeight + scrollTop) {
          // 如果下方空间不足，显示在选择文本上方
          top = rect.top + scrollTop - buttonHeight - 10;
        }
        
        setButtonPosition({ top, left });
      }
    };

    // 添加滚动和窗口大小变化事件监听器
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    
    // 初始位置计算
    handleScroll();
    
    // 清理事件监听器
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [selection]);

  const buttonStyle: React.CSSProperties = {
    position: 'absolute',
    top: buttonPosition.top,
    left: buttonPosition.left,
    zIndex: 9999,
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 12px',
    fontSize: '12px',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    transform: 'translateZ(0)' // 触发硬件加速，提高性能
  };
  

  return (
    (window as any).AGIMX_CONFIG.ENABLE_ADD_PAD && <button
      style={buttonStyle}
      onClick={onAddToDocument}
      onMouseDown={(e) => e.preventDefault()} // 防止失去选择
    >
      添加到文档
    </button>
  );
};

// import React, { useState, useEffect } from 'react';
// import { TextSelection } from '../../types/document';

// interface TextSelectionButtonProps {
//   selection: TextSelection;
//   onAddToDocument: () => void;
// }

// export const TextSelectionButton: React.FC<TextSelectionButtonProps> = ({
//   selection,
//   onAddToDocument
// }) => {
//   if (!selection?.rect) return null;

//   const [buttonPosition, setButtonPosition] = useState({
//     top: selection.rect.top - 40,
//     left: selection.rect.left + selection.rect.width / 2 - 60
//   });

//   useEffect(() => {
//     const handleScroll = () => {
//       // 获取当前选择的最新位置信息
//       const sel = window.getSelection();
//       if (sel && sel.rangeCount > 0) {
//         const range = sel.getRangeAt(0);
//         const rect = range.getBoundingClientRect();
        
//         // 计算按钮位置，确保在视窗内
//         const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//         const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        
//         // 基本位置计算（相对于视口）
//         let top = rect.top - 40;
//         let left = rect.left + rect.width / 2 - 60;
        
//         // 确保按钮在视窗内
//         const buttonWidth = 120; // 按钮大约宽度
//         const buttonHeight = 32;  // 按钮大约高度
        
//         // 检查是否超出右边界
//         if (left + buttonWidth > window.innerWidth) {
//           left = window.innerWidth - buttonWidth - 10;
//         }
        
//         // 检查是否超出左边界
//         if (left < 10) {
//           left = 10;
//         }
        
//         // 检查是否超出上边界
//         if (top < 10) {
//           // 如果上方空间不足，显示在选择文本下方
//           top = rect.bottom + 10;
//         }
        
//         // 检查是否超出下边界
//         if (top + buttonHeight > window.innerHeight) {
//           // 如果下方空间不足，显示在选择文本上方
//           top = rect.top - buttonHeight - 10;
//         }
        
//         setButtonPosition({ top, left });
//       }
//     };

//     // 添加滚动和窗口大小变化事件监听器
//     window.addEventListener('scroll', handleScroll);
//     window.addEventListener('resize', handleScroll);
    
//     // 初始位置计算
//     handleScroll();
    
//     // 清理事件监听器
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//       window.removeEventListener('resize', handleScroll);
//     };
//   }, [selection]);

//   const buttonStyle: React.CSSProperties = {
//     position: 'fixed',  // 改为fixed定位
//     top: buttonPosition.top,
//     left: buttonPosition.left,
//     zIndex: 9999,
//     backgroundColor: '#007bff',
//     color: 'white',
//     border: 'none',
//     borderRadius: '4px',
//     padding: '6px 12px',
//     fontSize: '12px',
//     cursor: 'pointer',
//     boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//     transform: 'translateZ(0)' // 触发硬件加速，提高性能
//   };
  

//   return (
//     (window as any).AGIMX_CONFIG.ENABLE_ADD_PAD && <button
//       style={buttonStyle}
//       onClick={onAddToDocument}
//       onMouseDown={(e) => e.preventDefault()} // 防止失去选择
//     >
//       添加到文档
//     </button>
//   );
// };